<template>
  <div>
    <el-tabs value="tab_user" type="border-card" v-model="activeName">
      <el-tab-pane label="月度账单" name="tab_user">

        <el-form ref="form" inline size="mini">

          <el-form-item label="选择日期：：">
            <el-radio-group v-model="radioMonth">
              <el-radio :label=0>{{ monthList[0] }}</el-radio>
              <el-radio :label=1>{{ monthList[1] }}</el-radio>
              <el-radio :label=2>{{ monthList[2] }}</el-radio>
              <el-radio :label=3>{{ monthList[3] }}</el-radio>
              <el-radio :label=4>{{ monthList[4] }}</el-radio>
              <el-radio :label=5>{{ monthList[5] }}</el-radio>
            </el-radio-group>
          </el-form-item>


          <el-form-item v-if="hasSubQiYe" label="选择企业：">
            <el-select  v-model= "qiyeId" >
              <el-option
                  v-for="item in qiyeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-button type="primary" @click="handleDown">下载订单数据</el-button>
        </el-form>

      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import * as _ from 'lodash';
import VueJsonEditor from '@/components/VueJsonEditor'
import Pagination from '@/components/Pagination'
import moment from "moment-timezone"
import constants, {
  ProductType,
  Role,
  PaymentState,
  getPayTypeDesc,
  getSaleChannelDesc,
  defaultTimeZone
} from "@/utils/constants";
import {getOptsList, OptsPayType, OptsSaleChannel, parseDownloadResponse} from "@/utils";


export default {
  components: {VueJsonEditor, Pagination},
  data() {

    const getMonthList = () => {
      let list = [];
      for (let i = 1; i <= 6; i++) {
        list.push(moment().subtract(i, 'months').startOf('month').format('YYYY-MM'));
      }
      return list;
    };

    const getQiyeId = () => {
      const {user} = this.$store.state;
      if (user.role === Role.Server) return "server";
      return user.qiyeId || "";
    };

    const hasSubQiYeList = () => {
      const {user} = this.$store.state;
      const isSever = user.role === Role.Server;
      const isQiyeHas = user.role === Role.QiYe && user.subQiYeList && user.subQiYeList.length != 0;
      return isSever || isQiyeHas;
    }

    return {
      user: this.$store.state.user,
      role: this.$store.state.user.role,
      Role,
      activeName: 'tab_user',
      monthList: getMonthList(),
      moment,
      radioMonth: 0,
      hasSubQiYe:hasSubQiYeList(),
      qiyeId: getQiyeId(),
      qiyeList: [],
    };
  },
  created() {
    this.current_app = this.$store.state.app;
    this.getQiyelist();
  },

  computed: {
    cur_app() {
      return this.$store.state.app;
    }
  },
  watch: {
    $route(to) {
      if (this.current_app === this.$store.state.app) {
        return
      }
    }
  },
  methods: {
    handleDown() {
      this.logining = true;
      const params = new URLSearchParams();
      params.append('qiyeid', this.qiyeId);
      const tt = this.monthList[this.radioMonth]
      params.append('time', tt);
      const fileName = `${tt}.zip`;
      console.log("handleDown::" + JSON.stringify(params));
      this.$axios.get(`/statistic/monthDown`, {
        params,
        responseType: 'blob',
      }).then(res => {
        this.$message.info('成功');
        parseDownloadResponse(res, fileName);
      }).catch(res => {
        this.$message.error(`失败：${res}`);
        this.logining = false;
      })
    },


    getQiyelist() {
      const {user} = this.$store.state;

      let qiyeList = [];

      if (user.role == Role.Server || user.role == Role.QiYe) {
        let params = {
          qiyeName: "",
          qiyeId: "",
          limit: 1000,
          offset: 0,
        };
        this.loading = true;
        this.$axios.post('/qiye/list', params).then(res => {
          this.$message.info('查询企业成功');
          qiyeList = res.qiye;
          this.dealQiYeList(qiyeList)
        }).catch(res => {
          this.loading = false;
        })
      }else {
        this.dealQiYeList(qiyeList);
      }

    },

    dealQiYeList(qiyeList) {
      const {user} = this.$store.state;
      if (user.role == Role.Server) {
        this.qiyeList = [{value: 'server', label: '全部'}];
        qiyeList.forEach(item => {
          var tmp = {
            value: item._id,
            label: item.name,
          };
          this.qiyeList.push(tmp);
        });
      } else if (user.role == Role.QiYe && user.subQiYeList && user.subQiYeList.length != 0) {

        this.qiyeList = [{value: user.qiyeId, label: "全部"}];

        user.subQiYeList.forEach(subqiyeid => {
          qiyeList.forEach(item => {
            if(subqiyeid == item._id) {
              var tmp = {
                value: item._id,
                label: item.name,
              };
              this.qiyeList.push(tmp);
            }
          });
        });
      }
    }
  },
};

</script>

<style>
.user-table-expand {
  font-size: 0;
}

.user-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.user-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.hide-expand .el-table__expand-column .el-icon {
  visibility: hidden;
}
</style>
